/**
 * Copyright 2023-2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { Controller, useFormContext } from "react-hook-form";
import { Dropdown, Label, Spacer, theme } from "@nordcloud/gnui";
import { ActionScope, ActionType } from "~/generated/graphql";
import { FormGroup } from "~/components";
import { ACTION_TYPE_LABEL_MAP } from "~/views/customActions/constants";
import { FormField } from "../../../formConfig";

type Props = {
  onTypeChange: (type: string) => void;
};

export function ActionTypeSelect({ onTypeChange }: Props) {
  const { control, formState, watch, clearErrors } = useFormContext();
  const scope = watch("scope");
  return (
    <>
      <FormGroup error={formState.errors[FormField.TYPE]}>
        <Label name="Action Type" required />
        <Controller
          control={control}
          name={FormField.TYPE}
          render={({ field: { onChange, value } }) => {
            return (
              <Dropdown
                name="Select Type"
                options={
                  scope === ActionScope.Plan ? planOptions : resourceOptions
                }
                onChange={(val: string) => {
                  clearErrors();
                  onTypeChange(val);
                  onChange(val);
                }}
                value={value}
                minNumOfOptionsToShowSearchBox={10}
              />
            );
          }}
        />
      </FormGroup>
      <Spacer height={theme.spacing.spacing04} />
    </>
  );
}

const planOptions = [
  {
    value: ActionType.AwsLambda,
    label: ACTION_TYPE_LABEL_MAP[ActionType.AwsLambda],
  },
  {
    value: ActionType.AzureFunction,
    label: ACTION_TYPE_LABEL_MAP[ActionType.AzureFunction],
  },
  {
    value: ActionType.Webhook,
    label: ACTION_TYPE_LABEL_MAP[ActionType.Webhook],
  },
];

const resourceOptions = [
  ...planOptions,
  {
    value: ActionType.SsmDocument,
    label: ACTION_TYPE_LABEL_MAP[ActionType.SsmDocument],
  },
  {
    value: ActionType.Script,
    label: ACTION_TYPE_LABEL_MAP[ActionType.Script],
  },
];
